import { useEffect, useState } from 'react';
import { Context as ResponsiveContext } from 'react-responsive';

import type { ReactElement, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  inferredScreenWidth: number;
};

export const ResponsiveContextProvider = ({
  children,
  inferredScreenWidth,
}: Props): ReactElement => {
  const [screenWidth, setScreenWidth] = useState(inferredScreenWidth);

  useEffect(() => {
    const updateScreenWidth = (): void => {
      setScreenWidth(window.innerWidth);
    };

    updateScreenWidth();
    window.addEventListener('resize', updateScreenWidth);

    return () => window.removeEventListener('resize', updateScreenWidth);
  }, []);

  return (
    <ResponsiveContext.Provider value={{ width: screenWidth }}>
      {children}
    </ResponsiveContext.Provider>
  );
};
